import { render, staticRenderFns } from "./AttendanceIpSettings.vue?vue&type=template&id=3162682a"
import script from "./AttendanceIpSettings.vue?vue&type=script&lang=js"
export * from "./AttendanceIpSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports